import { workspaceQuizURL } from './workspacesURLs';

type WorkspaceQuizParams = {
  workspaceId: string;
  workspaceQuizId: string;
};

export function deleteWorkspaceQuizUrl({
  workspaceId,
  workspaceQuizId,
}: WorkspaceQuizParams) {
  return () => {
    const url = workspaceQuizURL({ workspaceId, workspaceQuizId });
    return url.href;
  };
}

export function updateWorkspaceQuizUrl({
  workspaceId,
  workspaceQuizId,
}: WorkspaceQuizParams) {
  return ({ quizId }: { quizId: string | number }) => {
    const url = workspaceQuizURL({ workspaceId, workspaceQuizId });
    url.pathname += `/versions/${quizId}`;
    return url.href;
  };
}

type WorkspaceQuizQuestionParams = {
  quizId: number | string;
  questionId?: number | string | number[];
};

export function updateWorkspaceQuestionUrl({
  workspaceId,
  workspaceQuizId,
  usePlural,
}: WorkspaceQuizParams & { usePlural?: boolean }) {
  return ({ quizId, questionId }: WorkspaceQuizQuestionParams) => {
    const url = new URL(
      updateWorkspaceQuizUrl({ workspaceId, workspaceQuizId })({
        quizId,
      })
    );

    if (usePlural || Array.isArray(questionId)) {
      url.pathname += `/questions`;
    } else if (
      typeof questionId === 'string' ||
      typeof questionId === 'number'
    ) {
      url.pathname += `/questions/${questionId}`;
    } else {
      url.pathname += `/question`;
    }
    return url.href;
  };
}

export function updateWorkspaceQuestionOrderUrl({
  workspaceId,
  workspaceQuizId,
}: WorkspaceQuizParams) {
  return ({ quizId, questionId = '' }: WorkspaceQuizQuestionParams) => {
    const url = new URL(
      updateWorkspaceQuestionUrl({ workspaceId, workspaceQuizId })({
        quizId,
        questionId,
      })
    );
    url.pathname += '/move';
    return url.href;
  };
}
